module.exports = __webpack_public_path__ + "img/mbp_logo.0ea9e5ad.png";